export const countrySelector = ({
  country
}) => country;
export const isInANZSelector = state => {
  const country = countrySelector(state);
  return country === 'australia' || country === 'new zealand';
};